

import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useMemo } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useLanguage } from "../../context/LanguageContext";

gsap.registerPlugin(ScrollTrigger);

export const WhatsappTradings = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const containerRef = useRef(null);
  const cardRefs = useRef([]);
  const { language, translations } = useLanguage();

  const cards = useMemo(
    () => [
      {
        title: translations[language]?.whatsAppTrading?.title1,
        description: translations[language]?.whatsAppTrading?.description1,
        theme: "dark",
      },

      {
        title: translations[language]?.whatsAppTrading?.title2,
        description: translations[language]?.whatsAppTrading?.description2,
        theme: "light",
      },
    ],
    [translations, language]
  );

  useEffect(() => {
    if (isSmallScreen) return;

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top",
          end: `+=${(window.innerHeight + 100) * cards.length}`,
          scrub: 1,
          pin: true,
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      });

      cardRefs.current.forEach((card, index) => {
        if (!card) return;
        const wrapper = card.querySelector(".card-wrapper");

        if (index === 0) {
          // ✅ Show first card instantly
          gsap.set(card, {
            opacity: 1,
            y: 0,
            scale: 1,
          });
          return;
        }

        tl.fromTo(
          card,
          {
            opacity: 0,
            y: 100,
            scale: 0.95,
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.5,
            ease: "power2.inOut",
            onStart: () => {
              if (index === 1) {
                gsap.to(wrapper, {
                  paddingTop: 42,
                  duration: 1.2,
                  ease: "power2.inOut",
                });
              }
            },
            onReverseComplete: () => {
              if (index === 1) {
                gsap.to(wrapper, {
                  paddingTop: 0,
                  duration: 1.2,
                  ease: "power2.inOut",
                });
              }
            },
          },
          (index - 1) * 0.8 // Shift timeline to align with scroll
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, [cards.length]);


  // useEffect(() => {
  //   if (isSmallScreen) return; // ✅ Skip GSAP on small screens

  //   const ctx = gsap.context(() => {
  //     const tl = gsap.timeline({
  //       scrollTrigger: {
  //         trigger: containerRef.current,
  //         start: "top top",
  //         end: `+=${(window.innerHeight + 100) * cards.length}`,
  //         scrub: 1,
  //         pin: true,
  //         anticipatePin: 1,
  //         fastScrollEnd: true,
  //       },
  //     });

  //     cardRefs.current.forEach((card, index) => {
  //       const wrapper = card.querySelector(".card-wrapper");

  //       tl.fromTo(
  //         card,
  //         {
  //           opacity: 0,
  //           y: 100,
  //           scale: 0.95,
  //           duration: 0.5,
  //         },
  //         {
  //           opacity: 1,
  //           y: 0,
  //           scale: 1,
  //           duration: 1.5,
  //           ease: "power2.inOut",
  //           onStart: () => {
  //             if (index === 1) {
  //               gsap.to(wrapper, {
  //                 paddingTop: 42,
  //                 duration: 1.2,
  //                 ease: "power2.inOut",
  //               });
  //             }
  //           },
  //           onReverseComplete: () => {
  //             if (index === 1) {
  //               gsap.to(wrapper, {
  //                 paddingTop: 0,
  //                 duration: 1.2,
  //                 ease: "power2.inOut",
  //               });
  //             }
  //           },
  //         },
  //         index * 0.8
  //       );
  //     });
  //   }, containerRef);

  //   return () => ctx.revert();
  // }, [cards.length]);

  return (
    <Box
    // ref={containerRef}
    // sx={{
    //   py: { xs: 4, md: 8 },
    //   overflow: "hidden",
    //   position: "relative",
    //   // height: "100vh",
    // }}
    >
      <Box>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            // flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            gap: {xs:0,sm:2},
            padding: {
              xs: "0px", // small screens
              sm: "0px 0px 0px 0px", // ≥600px and up
            },
          }}
        >
          <Box textAlign={{ xs: "center", md: "center" }} sx={{ mt: { xs: 6, md: 0 } }}
>
            <Typography variant="h2">
              {translations[language]?.whatsAppTrading?.title}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "20px", md: "22px" },
                color: "rgba(102, 112, 133, 1)",
                fontWeight: 400,
                mt: 2,
                maxWidth: "480px",
                mx: { xs: "auto", md: 0 },
              }}
            >
              {translations[language]?.whatsAppTrading?.subtitle}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                disableRipple
                onClick={() => window.open("https://wa.me/96178709578", "_blank")}
                sx={{
                  background: "#4caf504f",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  boxShadow: "none",
                  alignSelf: { xs: "center", md: "center" },
                  mt: { xs: 2, md: 2 },
                  "&:hover": {
                    background: "#4caf504f",
                  },
                }}
              >
                <WhatsAppIcon sx={{ color: "#4CAF50" }} />
                <span
                  style={{ color: "#4CAF50", fontSize: "18px", fontWeight: 500 }}
                >
                  {translations[language]?.whatsAppTrading?.openWhatsApp}
                </span>
              </Button>
            </Box>
          </Box>

        </Box>

        {/* Scroll Cards */}
        <Box
          ref={containerRef}

          sx={{
            position: "relative",
            height: isSmallScreen ? "auto" : "100vh",
            mt: { xs: 4, md:0 },
            overflow: "hidden",
          }}
        >
          {cards.map((card, i) => (
            <Box
              key={i}
              ref={(el) => (cardRefs.current[i] = el)}
              mt={i === 0 ? 8 : 0}
              sx={{
                position: isSmallScreen
                  ? "relative"
                  : i === 0
                    ? "relative" // ✅ Always keep first card relative
                    : "absolute",
                // position: isSmallScreen
                //   ? "relative"
                //   : i === 0
                //     ? "relative"
                //     : "absolute",

                top: { xs: 0, sm: 30, md: 50 },
                left: 0,
                width: "100%",
                px: { xs: 1, sm: 2, md: 3 },
              }}
            >
              <Box
                className="card-wrapper"
                sx={{ transition: "padding-top 0.4s ease" }}
              >
                <Box
                  className="card-inner"
                  sx={{
                    width: "100%",
                    maxWidth: {
                      xs: "100%",
                      sm: i === 1 ? "95%" : "90%",
                      md: i === 1 ? "98%" : "95%",
                      lg: i === 1 ? "1540px" : "1500px",
                    },
                    height: {
                      xs: "auto",
                      sm: "400px",
                      md: "570px",
                      lg: "570px",
                    },
                    marginTop: { xs: 4, sm: 2, md: 0 },
                    minHeight: { xs: "350px", sm: "380px", md: "570px", lg: "570px", },
                    borderRadius: "25px",
                    overflow: "hidden",
                    backgroundColor:
                      card.theme === "dark" ? "#000000" : "#F3F5F7",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 1, sm: 2, md: 3 },
                    mx: "auto",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {/* Text Section */}
                  <Box
                    sx={{
                      flex: 1,
                      color: card.theme === "dark" ? "#fff" : "#000",
                      px: { xs: 2, sm: 3, md: 4, lg: 5 },
                      pt: { xs: 2.5, sm: 3, md: 4, lg: 5 },
                      pb: { xs: 2, sm: 2.5, md: 3 },
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 700,
                        fontSize: {
                          xs: "20px",
                          sm: "22px",
                          md: "26px",
                          lg: "30px",
                          xl: "36px",
                        },
                        lineHeight: '40px',
                        mb: { xs: 1.5, sm: 2 },
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: card.theme === "dark" ? "#ccc" : "#666",
                        fontSize: {
                          xs: "13px",
                          sm: "14px",
                          md: "15px",
                          lg: "16px",
                        },
                        fontWeight: 500,
                        lineHeight: "1.6",
                        maxWidth: { xs: "100%", sm: "95%", md: "90%" },
                      }}
                    >
                      {card.description}
                    </Typography>
                  </Box>


                  <Box
                    sx={{
                      flex: { xs: 1, md: 2 },
                      m: { xs: 1, sm: 1.5, md: 2 },
                      backgroundColor:
                        card.theme === "dark" ? "#27292b" : "#FFFFFF",
                      borderRadius: "20px",
                      height: {
                        xs: "calc(100% - 32px)",
                        sm: "calc(100% - 48px)",
                        md: "calc(100% - 32px)",
                      },
                      minHeight: {
                        xs: "120px",
                        sm: "140px",
                        md: "160px",
                      },
                    }}
                  >
                    <video
                      // className={styles.videoElement}
                      // src="/Images/bbCorpAI.mp4"
                      src={card?.theme === "dark" ? "/Images/Payments.mp4" : "/Images/bbCorpAI.mp4"}
                      autoPlay
                      muted
                      loop
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        position: { sm: "absolute", md: "absolute", lg: "absolute" },
                        top: card?.theme === "dark" ? 50 : 70,
                        left: "19%",
                        padding: 15,
                        // Optimize video performance
                        willChange: "transform",
                        backfaceVisibility: "hidden",
                      }}
                    />
                  </Box>

                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};